module.exports = __webpack_public_path__ + "static/media/Portrait-10246.aeb6dbcf.jpg";